<template>
    <div class="tags-wrapper mb-3 mb-md-0">
        <div v-for="tag in tags">
            <div class="tag">{{ tag }}</div>
        </div>
    </div>
</template>
  
<script>
export default {
    name: "categories-tag",
    props: ["categories"],
    data() {
        return {
            tags: []
        };
    },
    created() {
        this.setTags();
    },
    methods: {
        setTags() {
            if(this.categories) {
                this.tags = this.categories.split(";#").filter((tag) => tag !== "");
            }
        }
    }
};
</script>

<style scoped>
.tags-wrapper {
    display: flex;
    flex-wrap: wrap;
    gap: 7px;
}

.tag {
    background: var(--tag-color);
    font-size: 12px;
    border-radius: 2px;
    padding: 2px 7px;
    font-family: artifaktElementRegular;
}
</style>



// WEBPACK FOOTER //
// src/components/homebase/newsByInterests/CategoriesTag.vue